import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../store";
import { PageHeader, PrimaryButton } from "../components/UI";
import "../css/Profile.css";

export default function Profile() {
  const { user, updateUser, logout } = useApp();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.name || "");
  const [mobile, setMobile] = useState(user?.mobile || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    setName(user?.name || "");
    setMobile(user?.mobile || "");
    setEditing(false);
  }, [user]);

  async function save(event) {
    event.preventDefault();
    setError("");
    const cleanMobile = mobile.replace(/\D/g, "");
    if (!name.trim() || !/^[6-9]\d{9}$/.test(cleanMobile)) {
      setError("Enter your name and a valid 10-digit mobile number.");
      return;
    }
    setSaving(true);
    try {
      await updateUser({ name: name.trim(), mobile: cleanMobile });
      setEditing(false);
    } catch (err) {
      setError(err?.message || "Unable to update profile.");
    } finally {
      setSaving(false);
    }
  }

  const menu = [
    ["/deliveries", "fa-box", "My deliveries"],
    ["/addresses", "fa-location-dot", "Saved addresses"],
    ["/notifications", "fa-bell", "Notifications"],
    ["/help", "fa-circle-question", "Help & support"],
    ["/about", "fa-leaf", "About us"],
  ];

  return (
    <div className="page-wrap narrow container-xl">
      <PageHeader title="Profile" />

      <div className="profile-card">
        <div className="avatar">{user?.name?.[0]?.toUpperCase() || "F"}</div>

        <div className="flex-grow-1">
          <h2>{user?.name || "Welcome to FreshLoop"}</h2>

          {user ? (
            <p>
              {user.mobile}
              <br />
              {user.email}
            </p>
          ) : (
            <p>Login to view your deliveries</p>
          )}
        </div>

        {user && (
          <button
            className="icon-button"
            type="button"
            onClick={() => setEditing(true)}
            aria-label="Edit profile"
          >
            <i className="fa-solid fa-pen" />
          </button>
        )}
      </div>

      {editing && (
        <form className="form-card mt-3" onSubmit={save}>
          <h2>Edit profile</h2>
          <label className="form-label">Full name</label>
          <input
            className="form-control mb-3"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <label className="form-label">Mobile number</label>
          <input
            className="form-control mb-3"
            inputMode="numeric"
            maxLength={10}
            value={mobile}
            onChange={(e) =>
              setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            required
          />
          {error && <div className="alert alert-danger">{error}</div>}
          <div className="d-flex gap-2">
            <PrimaryButton type="submit" disabled={saving}>
              {saving ? "Saving…" : "Save"}
            </PrimaryButton>
            <button
              type="button"
              className="btn btn-soft"
              onClick={() => setEditing(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      <div className="action-list">
        {menu.map(([to, icon, label]) => (
          <Link key={to} to={to}>
            <i className={`fa-solid ${icon}`} />
            {label}
            <i className="fa-solid fa-chevron-right" />
          </Link>
        ))}
        <Link to="/about">
          <i className="fa-solid fa-file-lines" />
          Terms & privacy
          <i className="fa-solid fa-chevron-right" />
        </Link>
        {user ? (
          <button onClick={logout} className="profile-menu-item logout-item">
            <i className="fa-solid fa-right-from-bracket"></i>
            <span>Logout</span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        ) : (
          <button
            onClick={() => navigate("/login?redirect=/profile")}
            className="profile-menu-item login-item"
          >
            <i className="fa-solid fa-right-to-bracket"></i>
            <span>Login</span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        )}
      </div>
    </div>
  );
}
